import { Button } from '@newfront-insurance/core-ui/v2';
import { Loader2 } from 'lucide-react';
import type { ReactNode } from 'react';

import { type CustomSkillManagementTab } from './custom-skill-model';
import { CustomSkillTabs } from './custom-skill-tabs';
import { getErrorMessage } from '../../lib/error-message';

export function CustomSkillsCard({
  activeTab,
  mySkillCount,
  sharedSkillCount,
  showSharedSkills,
  isLoading,
  error,
  children,
  onRetry,
  onTabChange,
}: {
  activeTab: CustomSkillManagementTab;
  mySkillCount: number;
  sharedSkillCount: number;
  showSharedSkills: boolean;
  isLoading: boolean;
  error?: unknown;
  children: ReactNode;
  onRetry: () => void;
  onTabChange: (tab: CustomSkillManagementTab) => void;
}) {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
      {isLoading ? (
        <div className="flex items-center justify-center px-5 py-8">
          <Loader2 className="text-muted-foreground h-5 w-5 animate-spin" />
          <span className="text-muted-foreground ml-2 text-sm">Loading custom skills...</span>
        </div>
      ) : error ? (
        <div className="border-border bg-background mx-5 my-5 rounded-md border p-4">
          <p className="text-destructive text-sm">{getErrorMessage(error, 'Unable to load custom skills.')}</p>
          <Button type="button" className="mt-3" onClick={onRetry}>
            Retry
          </Button>
        </div>
      ) : (
        <>
          <div className="px-5 pt-3">
            <CustomSkillTabs
              activeTab={activeTab}
              mySkillCount={mySkillCount}
              sharedSkillCount={sharedSkillCount}
              showSharedSkills={showSharedSkills}
              showWtwSkills
              onChange={onTabChange}
            />
          </div>
          {children}
        </>
      )}
    </div>
  );
}
